type ApiTripWidget =
	| ApiTripWidgetTaskCounter
	| ApiTripWidgetTravelerCounter
	| ApiTripWidgetNoteCounter
	| ApiTripWidgetSpotCounter
	| ApiTripWallPinCounter
	| ApiTripWidgetItineraryCounter
	| ApiTripWidgetStore

enum API_TRIP_WIDGET_TYPE {
	TASK_COUNTER = 'task_counter',
	SPOT_COUNTER = 'spot_counter',
	TRAVELER_COUNTER = 'traveler_counter',
	NOTE_COUNTER = 'note_counter',
	WALL_PIN_COUNTER = 'wall_pin_counter',
	ITINERARY_COUNTER = 'itinerary_counter',
	STORE = 'store',
}

type ApiTripWidgetTaskCounter = {
	type: API_TRIP_WIDGET_TYPE.TASK_COUNTER
	data: ApiTripWidgetCounterData & {
		todo: number
		doing: number
		done: number
	}
}

type ApiTripWidgetTravelerCounter = {
	type: API_TRIP_WIDGET_TYPE.TRAVELER_COUNTER
	data: ApiTripWidgetCounterData & ApiTripWidgetPictureData
}

type ApiTripWidgetNoteCounter = {
	type: API_TRIP_WIDGET_TYPE.NOTE_COUNTER
	data: ApiTripWidgetCounterData
}

type ApiTripWallPinCounter = {
	type: API_TRIP_WIDGET_TYPE.WALL_PIN_COUNTER
	data: ApiTripWidgetCounterData
}

type ApiTripWidgetSpotCounter = {
	type: API_TRIP_WIDGET_TYPE.SPOT_COUNTER
	data: ApiTripWidgetCounterData & ApiTripWidgetPictureData
}

type ApiTripWidgetItineraryCounter = {
	type: API_TRIP_WIDGET_TYPE.ITINERARY_COUNTER
	data: ApiTripWidgetCounterData & ApiTripWidgetDatesData
}

type ApiTripWidgetCounterData = {
	total: number
}

type ApiTripWidgetPictureData = {
	picture_urls: string[]
}

type ApiTripWidgetDatesData = {
	start_date: string
	end_date: string
}

type ApiTripWidgetStore = {
	type: API_TRIP_WIDGET_TYPE.STORE
	data: {
		essentials: boolean
		activities: boolean
		ideas: boolean
	}
}

export {
	ApiTripWidget,
	API_TRIP_WIDGET_TYPE,
	ApiTripWidgetTaskCounter,
	ApiTripWidgetTravelerCounter,
	ApiTripWidgetNoteCounter,
	ApiTripWidgetSpotCounter,
	ApiTripWallPinCounter,
	ApiTripWidgetItineraryCounter,
	ApiTripWidgetStore,
}
